module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Views.5e90e1f4.PNG";